import { createContext } from 'react';
export const GridListContext = /*#__PURE__*/createContext({});
export const GridListSelectableContext = /*#__PURE__*/createContext({
  items: [],
  selectedItems: [],
  onSelect: () => {}
});